import { authInstance } from '@/api/core';
import requestHelper from '@/helpers/requestHelper';
export default class Requestor {
    defaultConfig;
    instance;
    constructor(instance) {
        this.instance = instance;
        this.defaultConfig = {};
    }
    get({ url, params, adapter }) {
        const getParam = {
            method: 'get',
            url,
            params,
        };
        if (adapter) {
            getParam.adapter = adapter;
        }
        const config = this.combineConfig(getParam);
        return this.request(config);
    }
    post({ url, data }) {
        const config = this.combineConfig({
            method: 'post',
            url,
            data,
        });
        return this.request(config);
    }
    put({ url, data }) {
        const config = this.combineConfig({
            method: 'put',
            url,
            data,
        });
        return this.request(config);
    }
    delete({ url, data }) {
        const config = this.combineConfig({
            method: 'delete',
            url,
            data,
        });
        return this.request(config);
    }
    combineConfig(config) {
        return {
            ...this.defaultConfig,
            ...config,
        };
    }
    request(config) {
        return requestHelper.run(async () => {
            // auth api
            if (authInstance === this.instance) {
                return this.instance(config);
            }
            // client api
            const response = await this.instance(config);
            return response;
        });
    }
}
